import React, { useState } from "react";
import { FiMessageCircle, FiX } from "react-icons/fi";
import QueryCenter from "./QueryCenter"; // This should be your message UI
import "./FloatingMessageCenter.css";

const FloatingQueryCenter = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMessageCenter = () => setIsOpen(!isOpen);

  return (
    <>
      <button className="chat-toggle-btn" onClick={toggleMessageCenter}>
        {isOpen ? <FiX size={24} /> : <FiMessageCircle size={24} />}
      </button>

      {isOpen && (
        <div className="floating-query-window">
          <QueryCenter closeButton={toggleMessageCenter}/>
        </div>
      )}
    </>
  );
};

export default FloatingQueryCenter;
